import React from 'react';
import SVGImage from '../layout/SVGImage';

interface GenerationStatusProps {
  text: string;
  isPlus?: boolean;
  className?: string;
}

const GenerationStatus: React.FC<GenerationStatusProps> = ({
  text,
  isPlus,
  className,
}) => {
  return (
    <div className={`${className} flex items-end pt-[1px]`}>
      {isPlus ? (
        <SVGImage name="north"></SVGImage>
      ) : (
        <SVGImage name="south"></SVGImage>
      )}
      <p
        className={`pop-11-bold ${isPlus ? 'text-red-main' : 'text-blue-main'} leading-none`}
      >
        {isPlus ? '+' : '-'}
        {text}
      </p>
    </div>
  );
};

export default GenerationStatus;
